import Home from 'pages/home/Home';

const Homepage = () => {
  return <Home />;
};

export default Homepage;
